import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { Header } from './components/layout/Header';
import { AuthModal } from './components/auth/AuthModal';
import { Landing } from './pages/Landing';
import { Browse } from './pages/Browse';
import { ListTool } from './pages/ListTool';
import { MyRentals } from './pages/MyRentals';
import { MyListings } from './pages/MyListings';
import { ToolDetail } from './pages/ToolDetail';
import { RentalDetail } from './pages/RentalDetail';
import { getOrCreateSessionId } from './utils/session';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

// Ensure anonymous session exists on app load
getOrCreateSessionId();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/list-tool" element={<ListTool />} />
          <Route path="/my-rentals" element={<MyRentals />} />
          <Route path="/my-listings" element={<MyListings />} />
          <Route path="/tools/:id" element={<ToolDetail />} />
          <Route path="/rentals/:id" element={<RentalDetail />} />
          <Route path="*" element={
            <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
              <div className="text-6xl mb-4">🦫</div>
              <h1 className="font-display font-extrabold text-3xl text-silver-800 mb-2">404</h1>
              <p className="text-silver-500 mb-6">Tim couldn't find that page!</p>
              <a href="/" className="btn-primary">Go Home</a>
            </div>
          } />
        </Routes>

        {/* Global auth modal */}
        <AuthModal />

        {/* Toast notifications */}
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              borderRadius: '16px',
              background: '#1a1a1a',
              color: '#fff',
              fontSize: '14px',
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
